// import React from "react";
import "./HealthTwoTopCereal.scss";

const HealthTwoTopCereal = () => {
  return (
    <div className="health-two-cereal-banner">
      <div className="content">
        <p className="flavor">Cereal Honey Flavour</p>
        <h2 className="title">Cereal Healthy Food</h2>
        <p className="description">
          cereal food offers many benefits that make it <br />a healthy and
          nutritious breakfast choice
        </p>
        <ul className="benefits">
          <li>Provides essential nutrients</li>
          <li>High in fiber</li>
          <li>Low in fat</li>
        </ul>
        <button className="buy-btn">
          Buy now from ₹50.00 <span className="arrow">&#10140;</span>
        </button>
      </div>

      <div className="product-image">
        <img
          src="/assets/img/health/healthTwo/images__2_-removebg-preview.png"
          alt="Cereal Box"
        />
      </div>
    </div>
  );
};

export default HealthTwoTopCereal;
